// src/v3/navigation/expand-menu.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ExpandMenuIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ExpandMenuIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.421 5.778a.79.79 0 0 1 1.579 0v12.444a.79.79 0 0 1-1.579 0V5.778Zm-7.463-.26 5.968 5.88-.01.021a.752.752 0 0 1 .231.57v.042a.793.793 0 0 1-.231.57l-5.969 5.88a.787.787 0 0 1-.557.229c-.2 0-.4-.073-.558-.229a.774.774 0 0 1 0-1.099l4.673-4.604H4.79A.79.79 0 0 1 4 12a.79.79 0 0 1 .79-.778h9.726L9.842 6.618a.774.774 0 0 1 0-1.1c.305-.3.81-.3 1.116 0Z",
    clipRule: "evenodd"
  }
) });

export {
  ExpandMenuIcon
};
